export const COVERED_OBJECTS_PAGE_SIZE = 15;

export const COVERED_OBJECTS_SEARCH_DEBOUNCE_MS = 300;

// Don't fire a search request until the user has typed enough to be useful —
// 1-2 chars produce a near-unbounded ILIKE that costs the DB without helping.
export const COVERED_OBJECTS_SEARCH_MIN_CHARS = 3;

// Cap default-field columns in the table so wide LOBs (e.g. auto, with ~18
// default fields) don't blow the table out. The view dialog still shows the
// full set.
export const COVERED_OBJECTS_TABLE_DEFAULT_FIELD_COLUMNS = 8;

// Below this count (applied to the TOTAL rows across all covered-object
// types on the tab, not per type), render covered objects inline as cards
// (2 per row) using the V1 CoveredEntityCard instead of the SortableTable.
// The table only pays off when there are enough rows to justify the
// horizontal density — 4 rows still fit cleanly as a 2x2 card grid.
export const COVERED_OBJECTS_CARDS_THRESHOLD = 5;
